module.exports = __webpack_public_path__ + "img/BG_header_client.2f8d6bfa.jpg";